export const REQUEST_USER_KEY = 'user';
export const SYSTEM_TENANT_ID = 'system';
export const EVAL_TENANT_ID = 'eval';
export const TERRA_EVALUATIONS_TENANT_ID = 'T3HzcIKZlV4VGPxGNTcJtF32DnbR';
export {
  COCKPIT_EXCLUDED_TENANT_ID_LIST,
  COCKPIT_EXCLUDED_TENANT_IDS,
} from './cockpit-excluded-tenant-ids';
export type { CockpitExcludedTenantId } from './cockpit-excluded-tenant-ids';

export const EVAL_SPEND_TENANT_IDS = [
  EVAL_TENANT_ID,
  TERRA_EVALUATIONS_TENANT_ID,
] as const;
export const AUTOMATION_EXCLUDED_TENANT_IDS = [EVAL_TENANT_ID] as const;

export function isAutomationEligibleTenant(
  tenantId: string | null | undefined,
): tenantId is string {
  return (
    typeof tenantId === 'string' &&
    tenantId.length > 0 &&
    !(AUTOMATION_EXCLUDED_TENANT_IDS as readonly string[]).includes(tenantId)
  );
}

export const GENERIC_ERROR_MESSAGE = 'unknown error';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const USER_FRIENDLY_TIMESTAMP_FORMAT = 'DD/MM/YYYY, HH:mm:ss';
export const TIMESTAMP_FORMAT_WITH_TZ = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export enum ENVIRONMENT_TYPES {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}
export const UNASSIGNED_ASSIGNEE_ID = 'UNASSIGNED';
export type {
  EvaluationInferenceProviderId,
  EvaluationModelVendor,
  EvaluationReasoningEffort,
} from './evaluation-inference-providers';
export {
  EVALUATION_INFERENCE_PROVIDER_IDS,
  EVALUATION_REASONING_EFFORTS,
} from './evaluation-inference-providers';
export type {
  EvaluationPlaybookPhase,
  EvaluationPlaybookPhasesFilterShape,
} from './evaluation-playbook-phases';
export {
  EVALUATION_OVERLAY_MAX_BYTES,
  EVALUATION_PLAYBOOK_OVERRIDE_MAX_CATEGORIES,
  EVALUATION_PLAYBOOK_OVERRIDE_MAX_CHARS,
  EVALUATION_PLAYBOOK_PHASES,
  evaluationOverlayByteLength,
  evaluationOverlayExceedsMaxBytes,
  findContradictoryPlaybookPhases,
  isEvaluationPlaybookPhaseEnabled,
} from './evaluation-playbook-phases';
export type { EvaluationDecisionMetric } from './evaluation-decision-metrics';
export { EVALUATION_DECISION_METRICS } from './evaluation-decision-metrics';
export {
  SIGNAL_NOT_REJECTED_PRISMA_WHERE,
  SIGNAL_NOT_REJECTED_MONGO_MATCH,
} from './signal-not-rejected';
export type { SkillAgentId } from './copilot-skill-bundles.constants';
export {
  SUBAGENT_SKILLS_PATH_PREFIX,
  SKILLS_PATH_PREFIX,
  CUSTOMER_SKILLS_PATH_PREFIX,
  TESTING_INSTRUCTIONS_PATH_PREFIX,
  MEMORIES_PATH_PREFIX,
  COPILOT_CONTEXT_SKILL_PATHS,
  COPILOT_MAIN_AGENT_SKILL_BUNDLES,
  BOOTH_COPILOT_SKILL_BUNDLE,
  COPILOT_SUBAGENT_SKILL_BUNDLES,
  EXTERNAL_NETWORK_MAIN_AGENT_SKILL_BUNDLES,
  EXTERNAL_NETWORK_SUBAGENT_SKILL_BUNDLES,
  PLATFORM_SKILL_TENANT_ID,
  KNOWN_SKILL_AGENT_IDS,
} from './copilot-skill-bundles.constants';
